import Axios from 'axios';
import { baseURL } from '@/store/uri';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorMessage?: boolean;
    skipErrorMsgByStatuses?: number[];
    excludeStatuses?: number[];
  }
}

const axios = Axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 0, // Выключить таймаут
  maxContentLength: Infinity, // Убираем лимит размера
  maxBodyLength: Infinity,
});

// if (process.env.VUE_APP_MOCK === 'true') {
//
// }
export { axios };
